import React from "react";
import {TableData} from "../../../models/TableProps";
import {IconSVG} from "../../../../../ui/icon/IconSVG";

const TableHeader = ({columns, orderBy, setOrderBy}: {
    columns: TableData[], orderBy?: { name: string, order?: string }, setOrderBy?: ({
                                                                                        name,
                                                                                        order
                                                                                    }: { name: string, order?: string }) => void
}) => {
    return (
        <thead>
        <tr>
            {columns.map((ele) => {
                return <th key={ele.name} style={{width: ele?.width, ...ele?._style }}>
                    <div className={`d-flex gap-2 ${ele.sortable ? 'pointer' : ''}`}
                         onClick={() => ele.sortable && (setOrderBy && setOrderBy({
                             name: ele.orderColName ? ele.orderColName : ele.name,
                             order: orderBy?.order == 'asc' ? 'desc' : 'asc'
                         }))}>

                        {ele.label}
                        {ele.sortable &&
                            (
                                orderBy?.name == (ele.orderColName ? ele.orderColName : ele.name) ? <div>
                                        {orderBy?.order == 'asc' ?
                                            <IconSVG icon={'col-asc'} size={'10px'} tintColor={'#666'}/>
                                            :
                                            <IconSVG icon={'col-desc'} size={'10px'} tintColor={'#666'}/>}
                                    </div>
                                    :
                                    <div><IconSVG icon={'col-order'} size={'10px'} tintColor={'#666'}/></div>)
                        }

                    </div>
                </th>
            })}
        </tr>
        </thead>
    );
};
export default TableHeader;
